export default __webpack_public_path__ + "static/logo-8ed0fca8af3e379cfcd9047bfb7e0486.svg";